var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiText',{staticClass:"registration-block__text custom-scrollbar__label",attrs:{"text":_vm.$tc('regAuthForgot.labels.or'),"font":"body-heading-5","color":"neutral-500","align-center":""}})}
var staticRenderFns = []

export { render, staticRenderFns }